import { getAssetUrl } from '@/utils/common';
import { CharacterRoutePlaceInfo } from '@/store/types';


export const themeSpots: any = [
  {
    x: 25,
    y: 30
  },
  {
    x: 39,
    y: 30
  },
  {
    x: 53,
    y: 30
  },
  {
    x: 67,
    y: 30
  },
  {
    x: 82,
    y: 30
  },
  {
    x: 96,
    y: 30
  }
];

export const characterSpots: any = [
  {
    id: '1',
    name: '白居易',
    birthDay: 772,
    addr: '山西太原',
    avatar: getAssetUrl('images/bg.png'),
    description: '白居易（772年－846年），字乐天，号香山居士，唐代著名诗人。曾任杭州刺史，在任期间疏浚西湖，修筑白堤，为杭州的发展做出了重要贡献。',
    x: 16,
    y: 17
  },
  {
    id: '2',
    name: '苏东坡',
    birthDay: 852,
    addr: '山西太原',
    avatar: getAssetUrl('images/bg.png'),
    description: '苏轼（1037年－1101年），字子瞻，号东坡居士，北宋文学家、政治家。曾任杭州知州，在任期间疏浚西湖，修筑苏堤，留下了许多描写西湖的诗词。',
    x: 28,
    y: 17
  },
  {
    id: '3',
    name: '林逋',
    birthDay: 1037,
    addr: '山西太原',
    avatar: getAssetUrl('images/bg.png'),
    description: '林逋（967年－1030年），字君复，号梅妻鹤子，北宋隐士。隐居西湖孤山，以梅为妻，以鹤为子，留下了许多描写西湖的诗作。',
    x: 40,
    y: 17
  },
  {
    id: '4',
    name: '岳飞',
    birthDay: 1103,
    addr: '山西太原',
    avatar: getAssetUrl('images/bg.png'),
    description: '岳飞（1103年－1142年），字鹏举，南宋抗金名将。曾在杭州驻军，留下了"还我河山"的千古名句。',
    x: 52,
    y: 17
  },
  {
    id: '5',
    name: '张岱',
    birthDay: 1125,
    addr: '山西太原',
    avatar: getAssetUrl('images/bg.png'),
    description: '张岱（1597年－1689年），字宗子，号陶庵，明末清初文学家。著有《西湖梦寻》，详细记载了西湖的风景名胜。',
    x: 64,
    y: 17
  },
  {
    id: '6',
    name: '李渔',
    birthDay: 1597,
    addr: '山西太原',
    avatar: getAssetUrl('images/bg.png'),
    description: '李渔（1611年－1680年），字笠翁，号随园，明末清初文学家。著有《闲情偶寄》，其中多有描写西湖的篇章。',
    x: 76,
    y: 17
  },
  // {
  //   id: '7',
  //   name: '袁枚',
  //   birthDay: 1881,
  //   addr: '山西太原',
  //   avatar: getAssetUrl('images/bg.png'),
  //   description: '袁枚（1716年－1797年），字子才，号随园，清代文学家。曾任杭州知府，著有《随园诗话》，其中多有描写西湖的诗作。',
  //   x: 66,
  //   y: 30
  // },
  // {
  //   id: '8',
  //   name: '郁达夫',
  //   birthDay: 1883,
  //   addr: '山西太原',
  //   avatar: getAssetUrl('images/bg.png'),
  //   description: '郁达夫（1896年－1945年），现代作家。曾在杭州居住，著有《沉沦》等作品，其中多有描写西湖的篇章。',
  //   x: 76,
  //   y: 30
  // },
  // {
  //   id: '9',
  //   name: '郁达夫',
  //   birthDay: 1883,
  //   addr: '山西太原',
  //   avatar: getAssetUrl('images/bg.png'),
  //   description: '郁达夫（1896年－1945年），现代作家。曾在杭州居住，著有《沉沦》等作品，其中多有描写西湖的篇章。',
  //   x: 86,
  //   y: 30
  // },
];

